import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FaUserShield, FaShieldAlt } from 'react-icons/fa';
import { MdPeople } from 'react-icons/md';
import { Pagination } from 'components/common';

const PER_PAGE = 6;

const RoleCard = ({ role }) => (
  <Link
    to={`/authorization/roles/${role.id}`}
    className="tw-block tw-no-underline tw-group"
  >
    <div className="tw-flex tw-items-center tw-gap-3 tw-px-4 tw-py-3 tw-rounded tw-border tw-border-gray-100 tw-bg-gray-50 hover:tw-bg-blue-50 hover:tw-border-blue-200 tw-transition-all tw-duration-150">
      <div className="tw-w-8 tw-h-8 tw-rounded-xl tw-bg-blue-100 tw-flex tw-items-center tw-justify-center tw-shrink-0 group-hover:tw-bg-blue-200 tw-transition-colors">
        <FaShieldAlt size={13} className="tw-text-blue-600" />
      </div>
      <div className="tw-flex-1 tw-min-w-0">
        <p className="tw-text-sm tw-font-semibold tw-text-gray-800 tw-mb-0 tw-truncate group-hover:tw-text-blue-700">
          {role.name}
        </p>
        <p className="tw-text-xs tw-text-gray-400 tw-mb-0">ID#{role.id}</p>
      </div>
      {role.permissions_count !== undefined && (
        <span className="tw-inline-flex tw-items-center tw-gap-1 tw-text-xs tw-font-medium tw-text-gray-500 tw-shrink-0">
          <FaUserShield size={10} />
          {role.permissions_count}
        </span>
      )}
    </div>
  </Link>
);

RoleCard.propTypes = { role: PropTypes.object.isRequired };

const UserRoleList = ({ roles = [] }) => {
  const [page, setPage] = useState(1);
  const total = roles.length;
  const totalPages = Math.max(1, Math.ceil(total / PER_PAGE));
  const displayed = roles.slice((page - 1) * PER_PAGE, page * PER_PAGE);

  if (total === 0) {
    return (
      <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-10 tw-text-gray-400">
        <MdPeople size={36} className="tw-mb-2 tw-opacity-40" />
        <p className="tw-text-sm">No roles assigned</p>
      </div>
    );
  }

  return (
    <div>
      <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-2 tw-mb-4">
        {displayed.map(role => (
          <RoleCard key={role.id} role={role} />
        ))}
      </div>
      {totalPages > 1 && (
        <Pagination
          compact
          currentPage={page}
          totalPages={totalPages}
          totalResults={total}
          perPage={PER_PAGE}
          onPageChange={setPage}
          className="tw-border-t tw-border-gray-100 tw-pt-3"
        />
      )}
    </div>
  );
};

UserRoleList.propTypes = {
  roles: PropTypes.arrayOf(PropTypes.object),
};

export default UserRoleList;
